import { backOfThumb } from './backOfThumb'

export const backOfThumbDrawer = async (
  ctx: CanvasRenderingContext2D,
  thumbColor: string,
  stitchColor: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  await backOfThumb(ctx, thumbColor, stitchColor, printLeatherTypeValue)
}
